import { render } from "./EnergyProduction.vue?vue&type=template&id=60e32fc3&scoped=true"
import script from "./EnergyProduction.vue?vue&type=script&lang=js"
export * from "./EnergyProduction.vue?vue&type=script&lang=js"

import "./EnergyProduction.vue?vue&type=style&index=0&id=60e32fc3&scoped=true&lang=css"

import exportComponent from "/usr/src/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-60e32fc3"]])

export default __exports__